module.exports = __webpack_public_path__ + "static/media/outcome_version_1.f2827ee1.png";